import { render, staticRenderFns } from "./AuthorizedSignaturesSection.vue?vue&type=template&id=a7aa3b0e&scoped=true"
import script from "./AuthorizedSignaturesSection.vue?vue&type=script&lang=js"
export * from "./AuthorizedSignaturesSection.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedSignaturesSection.vue?vue&type=style&index=0&id=a7aa3b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7aa3b0e",
  null
  
)

export default component.exports